import { api } from '@alpha/api-client';
import { useQuery } from '@tanstack/react-query';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { PageHeader } from '../../components/PageHeader';
import { useTableQuery } from '../../hooks/useTableQuery';
import { formatNumber, formatUsd } from '../../lib/format';
import { Card, Input, Spinner, StatCard, StatCards } from '../../ui';
import { WITHDRAWAL_TABS } from './WithdrawalList';

export function WithdrawalReports() {
  const { query, setParam } = useTableQuery();

  const { data, isLoading } = useQuery({
    queryKey: ['withdrawal-report', query],
    queryFn: () => api.withdrawals.report(query).then((r) => r.data),
  });

  return (
    <>
      <PageHeader
        title="Withdrawal Reports"
        tabs={WITHDRAWAL_TABS}
        actions={
          <>
            <Input
              type="date"
              defaultValue={(query.from as string) ?? ''}
              onChange={(e) => setParam('from', e.target.value)}
            />
            <Input
              type="date"
              defaultValue={(query.to as string) ?? ''}
              onChange={(e) => setParam('to', e.target.value)}
            />
          </>
        }
      />

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <StatCards>
            <StatCard label="Total Paid" value={formatUsd(data?.total_usd)} />
            <StatCard label="Requests" value={formatNumber(data?.total_count)} />
          </StatCards>

          <Card>
            <h3 className="card-title">Payouts by day</h3>
            <div style={{ width: '100%', height: 300 }}>
              <ResponsiveContainer>
                <BarChart data={data?.rows ?? []}>
                  <CartesianGrid stroke="#1c1c1c" vertical={false} />
                  <XAxis dataKey="date" stroke="#888" fontSize={12} tickLine={false} />
                  <YAxis stroke="#888" fontSize={12} tickLine={false} axisLine={false} />
                  <Tooltip
                    contentStyle={{ background: '#161616', border: '1px solid #2a2a2a', borderRadius: 8 }}
                  />
                  <Bar dataKey="amount_usd" fill="#c9a84c" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </>
      )}
    </>
  );
}
